module.exports = __webpack_public_path__ + "static/media/Don't Stand a Chance.56d08bbd.jpg";